export default "__VITE_ASSET__YqpjzAxG__"